$(document).ready(function () {
    $(".cv-review").click(function () {
        $("li.review_tab a").trigger("click");
    });
    var a = $("#countpagination").find("span").length - 1;
    $(window).scroll(function () {
        var d = $("#AjaxinatePagination").text();
        var c = "";
        $(".whenproductsaresold").each(function () {
            c += $(this).html();
        });
        $(".whenproductsaresold").remove();
        $("#AjaxinateContainersoldoutproduct").append(c);
        if (!$.trim($("#AjaxinatePagination").html()).length) {
            var e = $("#itsdone").val();
            if (e === "done") {
                var b = $("#AjaxinateContainersoldoutproduct").html();
                $("#AjaxinateContainer").append(b);
                $("#itsdone").val("0");
                $("#AjaxinateContainersoldoutproduct").html(" ");
            }
        }
    });

  $('.collection__description .readmore').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.collection__description .product-description-full');
    descriptionFull.style.display = 'block';
    var descriptionShort = document.querySelector('.collection__description .product-description-short');
    descriptionShort.style.display = 'none';
  });
  $('.collection__description .readless').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.collection__description .product-description-full');
    descriptionFull.style.display = 'none';
    var descriptionShort = document.querySelector('.collection__description .product-description-short');
    descriptionShort.style.display = 'block';
    // window.scrollTo({top: 110, behavior: 'smooth'});
  })

  if($('#saleendsin').length > 0){
    var endtime = $('#saleendsin').attr('data-expired_date');
    // Set the date we're counting down to
    var countDownDate = new Date(endtime).getTime();
    
    // Update the count down every 1 second
    var x = setInterval(function() {
    
      // Get today's date and time
      var now = new Date().getTime();
        
      // Find the distance between now and the count down date
      var distance = countDownDate - now;
        
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));   
      var dayshtml = '';
      if(days > 0){
        dayshtml = '<span class="value">'+days+'d</span><span>:</span>';
      }
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));      
      if(hours < 10){
        hours = '0'+hours; 
      } 
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      if(minutes < 10){
        minutes = '0'+minutes; 
      } 
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      if(seconds < 10){
        seconds = '0'+seconds; 
      } 
        
      // Output the result in an element with id="demo"
      document.getElementById("saleendsin").innerHTML = dayshtml+'<span class="value">'+hours+'h</span><span>:</span><span class="value">'+minutes+'m</span><span>:</span><span class="value">'+seconds+'s</span>';
        
      // If the count down is over, write some text 
      if (distance < 0) {
        clearInterval(x);
        document.getElementById("timer_wrapper").style.display = "none";
      }
    }, 1000);
  }

  if($('#CollectionAjaxContent .grid__item--sidebar').length > 0){
   $(window).scroll(function() {
    if ($(document).scrollTop() > 250) {
      $("#CollectionAjaxContent .grid__item--sidebar").addClass("test_sidebar");
    } else {
      $("#CollectionAjaxContent .grid__item--sidebar").removeClass("test_sidebar");
    }
  }); 
  } 

  // Clear URL parameters without reloading the page
  function clearURLParameters() {
    // Get the current URL
    const url = new URL(window.location.href);
  
    // Remove all query parameters
    url.search = "";
  
    // Optionally, remove the fragment (everything after #)
    url.hash = "";
  
    // Update the URL without reloading the page
    window.history.replaceState(null, null, url.toString());
  }
  
  var live_url = window.location.href;
  var result = live_url.includes('form_type=customer');
  var resultischal = live_url.includes('/challenge');
  if(result && !resultischal && $('#newsletter-footer').length != 0 && $('#newsletter-footer .errors').length == 0){
      const add_ele = document.createElement("p");
      add_ele.innerText = "You have already subscribed!";
      $('#newsletter-footer').prepend(add_ele);
      add_ele.classList.add('newsletter_already_subscribe','newsletter-form__message','form__message');
      if($(window).width() < 767){
       $('.footer_newsletter_trigger').trigger('click'); 
      }      
      clearURLParameters();
  }
  if(live_url.includes('/challenge')){
    setTimeout(function(){
      window.scrollTo({top: 0, behavior: 'smooth'});
    },2000);    
  }

  if((window.location.href.includes('sort_by') || window.location.href.includes('page')) && $(".main-collection-grid").length > 0){  
    window.scrollTo({top: $(".main-collection-grid").offset().top, behavior: 'smooth'});
  }

  if($('.havetotrigger').length > 0){
    $('.havetotrigger').trigger('click');
  }
  
  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
  var header = $(".product-single__meta .sticky_atc_wrapper");
  if($('body').hasClass('template-product')){
    
    if ($(".product-single__meta .buybutton_block").isInViewport()) {      
      header.removeClass("is-fixed");
      header.closest('.product-block').removeAttr('style');
    }else{      
       header.addClass("is-fixed");
       header.closest('.product-block').attr('style','padding-top: '+ header.outerHeight() +'px;');
    }
     $(window).scroll(function() {    
      if ($(".product-single__meta .buybutton_block").isInViewport()) {      
        header.removeClass("is-fixed");
        header.closest('.product-block').removeAttr('style');
      }else{      
         header.addClass("is-fixed");
         header.closest('.product-block').attr('style','padding-top: '+ header.outerHeight() +'px;');
      }
     });
  }

  // PRODUCT OFFERS COPY CODE
  $('.product-offer-header').click(function(){
   $(this).toggleClass('active');
   $(this).next().slideToggle();
  });
  
  $("body").on("click", ".product-offer-copy-code", function () {
    var copy_text = $(this);
    var text = $(this).parent().find('.product-offer-code').text();
    var $temp = $("<input>");
      
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.html('Copied');
      
    setTimeout(function () {
      copy_text.html('Copy');
    }, 1000);
  });

  // PDP Product Tabs  
  $("body").on("click",".btn-tab-pro", function(){
    var btnId = $(this).attr('data-pro');
    if($(this).hasClass('activee')){
      $(this).closest('.pdp-tab-slct-optn-tabs').find('.btn-tab-pro').removeClass('activee')
      $(this).closest('.pdp-tab-slct-optn-wrap').find('.pdp-tab-slct-optn-pro-blck').addClass('hide');
    }else{
      $(this).closest('.pdp-tab-slct-optn-tabs').find('.btn-tab-pro').removeClass('activee')
      $(this).addClass('activee')
      $(this).closest('.pdp-tab-slct-optn-wrap').find('.pdp-tab-slct-optn-pro-blck').addClass('hide');
      $(this).closest('.pdp-tab-slct-optn-wrap').find('[data-list="'+btnId+'"]').removeClass('hide');  
    }
    
  });

  $('.custom-blogs_wrapper').slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.logo-bar').slick({
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true
        }
      }
    ]
  });
  $('.mwt-media_col-slider').slick({
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000
  });
});






